<script lang="ts" setup>
import NavBar from '../components/layout/NavBar.vue'
import PromptBar from '~/components/PromptBar.vue'
import Toast from '~/components/UIComponents/Toast.vue'
import { useDarkMode } from '~/composables/useDarkMode'

useDarkMode()
</script>

<template>
  <div class="main">
    <NavBar class="nav-bar" />
    <PromptBar />
    <div class="layout-main-body">
      <div class="toast-overlay">
        <Toast class="toast" />
      </div>
      <div class="narrow-container">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style>
h1 {
  font-size: 1.2rem;
  font-family: var(--title-font);
  font-weight: 600;
  color: var(--text-color);
  margin-top: 1rem;
}

p {
  font-family: var(--title-font);
  font-weight: 400;
  margin: 0;
}
</style>

<style scoped>
.narrow-container {
  box-sizing: content-box;
  max-inline-size: 40ch;
  margin-inline: auto;
  padding-inline: var(--s-2);
  text-align: center;
}

@media screen and (max-width: 768px) {
  .narrow-container {
    padding-inline: 1rem;
  }
}
.main {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 64px min-content auto;
  grid-template-areas:
    'nav-bar'
    'prompt-bar'
    'main-body';
  flex-direction: column;
  justify-content: stretch;
  height: 100dvh;
  width: 100dvw;
  box-sizing: border-box;
  background-color: var(--background-color);
  font-family: var(--title-font);
}

.toast-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  z-index: var(--z-toast);

  display: flex;
  justify-content: center;
  pointer-events: none;
}

.layout-main-body {
  overflow-y: auto;
  min-height: 0;
  grid-area: main-body;
}
</style>
